import axiosInstance from "../../utils/AxiosInstance";

export interface PromptListItem {
  name: string;
  currentVersion: string | null;
  versionCount: number;
  configured: boolean;
}

export interface PromptVersion {
  id: string;
  version: string;
  prompt: string;
  role: string;
}

export interface PromptDetail {
  name: string;
  currentVersion: string | null;
  versions: PromptVersion[];
}

export function listPrompts(): Promise<PromptListItem[]> {
  return axiosInstance.get<PromptListItem[]>("/prompts").then((response) => response.data);
}

export function getPrompt(name: string): Promise<PromptDetail> {
  return axiosInstance.get<PromptDetail>(`/prompts/${encodeURIComponent(name)}`).then((response) => response.data);
}

export function createPromptVersion(name: string, prompt: string, role: string): Promise<PromptVersion> {
  return axiosInstance
    .post<PromptVersion>(`/prompts/${encodeURIComponent(name)}/versions`, {
      prompt,
      role,
    })
    .then((response) => response.data);
}
